<template>
    <section id="header" class="header-area" :class="isStickyHeader ? 'sticky': ''">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <nav class="navbar navbar-expand-lg">
                        <inertia-link href="/" class="navbar-brand">
                            <img src="/images/logo.png">
                        </inertia-link>
                        <inertia-link href="/" class="navbar-brand">
                            <img :src="clientLogo" class="p-1">
                        </inertia-link>
                    </nav> <!-- navbar -->
                </div>
            </div> <!-- row -->
        </div> <!-- container -->
    </section>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            isStickyHeader: false,
            isMobileMenu: false,
            clientLogo: this.$page.props.clientPage.logo,
        }
    },
    methods: {
        navToggle(e) {
            this.isMobileMenu = !this.isMobileMenu
        },
        handleScroll (event) {
            this.isStickyHeader = window.pageYOffset >= 10
        },
        isUrl(...urls) {
            let currentUrl = this.$page.url.substr(1)
            if (urls[0] === '') {add_addl_int_name_addl_int_address_to_clients_table
                return currentUrl === ''
            }
            return urls.filter(url => currentUrl.startsWith(url)).length
        },
    }
}
</script>
